import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.sass';

//Components
import Prefooter from './Prefooter';

//Images
import logo from '../../images/logo_header.png';
import MAIL from './icons/mail_icon.svg';
import WHATSAPP from './icons/whatsapp_icon.svg';
import PHONE from './icons/phone_icon.svg';
import LOCK from './icons/lock.svg';
import VERIFIED from './icons/verified.svg';
import FB from './icons/fb_icon.svg';
import YT from './icons/yt_icon.svg';
import INSTA from './icons/icono-instagram.svg';
import TIKTOK from './icons/icono-tiktok.svg';
import TWITTER from './icons/icono-x.svg';

const Footer = (props) => {
  const { device } = props;
  const { screenSize } = device;
  const { t } = useTranslation('footer');

  const securityText = t('security').split('<br/>');

  const whatsappNumbers = ['5542477210', '3329854884', '3310797297'];
  // Genera un índice aleatorio para seleccionar un número entre el 0, 1 o 2
  const numeroAleatorio = whatsappNumbers[Math.floor(Math.random() * whatsappNumbers.length)];
  const enlaceWhatsApp = `https://api.whatsapp.com/send?phone=${numeroAleatorio}&text=Hola!%20Quiero%20recibir%20información`;

  return (
    <div id={styles.Footer} className={styles[screenSize]}>
      <Prefooter device={device} />
      <div className={styles.lastFooter}>
        <div className={styles.lastFooterColumns}>
          <div className={`${styles.footerColumn} ${styles.first}`}>
            <div className={styles.contactTitle}>{t('contactTitle')}</div>

            <div className={styles.contactData}>
              <img className={styles.footerIcon} src={MAIL} alt='' />
              <a
                href='mailto:callcenter@terramarbrands.com'
                target='_blank'
                without='true'
                rel='noopener noreferrer'>
                <span className={styles.numeros}>{t('sendMail')}</span>
              </a>
            </div>

            <div className={styles.contactData}>
              <img className={styles.footerIcon} src={PHONE} alt='' />
              <a href='tel:3332681430' target='_blank' rel='noopener noreferrer'>
                <span className={styles.numeros}>33 32 68 14 30</span>
              </a>
              &nbsp; / &nbsp;
              <a href='tel:3321014729' target='_blank' rel='noopener noreferrer'>
                <span className={styles.numeros}>33 21 01 47 29</span>
              </a>
            </div>

            <div className={styles.contactData}>
              <img className={styles.footerIcon} src={WHATSAPP} alt='' />
              <a
                href='https://api.whatsapp.com/send?phone=5542477210&text=Hola!%20Quiero%20recibir%20información'
                target='_blank'
                rel='noopener noreferrer'>
                <span className={styles.numeros}>55 42 47 72 10 - Zona Norte</span>
              </a>
            </div>
            <div className={styles.contactData}>
              <img className={styles.footerIcon} src={WHATSAPP} alt='' />
              <a
                href='https://api.whatsapp.com/send?phone=3329854884&text=Hola!%20Quiero%20recibir%20información'
                target='_blank'
                rel='noopener noreferrer'>
                <span className={styles.numeros}>33 29 85 48 84 - Zona Centro</span>
              </a>
            </div>
            <div className={styles.contactData}>
              <img className={styles.footerIcon} src={WHATSAPP} alt='' />
              <a
                href='https://api.whatsapp.com/send?phone=3310797297&text=Hola!%20Quiero%20recibir%20información'
                target='_blank'
                rel='noopener noreferrer'>
                <span className={styles.numeros}>33 10 79 72 97 - Zona Sur</span>
              </a>
            </div>

            <div className={styles.contactData}>
              <a
                href='https://admin.terramarbrands.com.mx/'
                target='_blank'
                rel='noopener noreferrer'>
                <span className={styles.numeros}>{t('admin')}</span>
              </a>
            </div>
          </div>
          <div className={`${styles.footerColumn} ${styles.logoContainer}`}>
            {screenSize !== 'phone' && (
              <img className={styles.logo} src={logo} alt='Terramar Logo' />
            )}
            <div className={styles.securityIcons}>
              <img src={VERIFIED} alt='' />
              <img src={LOCK} alt='' />
            </div>
            {securityText.map((val, key) => {
              return (
                <div className={styles.securityText} key={key}>
                  {val}
                </div>
              );
            })}

            {/* Aviso Cofrepris */}

            <div className={styles.cofepris}>
              <div>Salud es belleza</div>
              <div>COFEPRIS AVISO DE PUBLICIDAD</div>
              <div>2609142002D00010</div>
            </div>

            {/** fin aviso cofepris */}
          </div>
          <div className={`${styles.footerColumn}`}>
            <div className={styles.titleSocial}>{t('socialTitle')}</div>
            <div className={styles.socialIcons}>
              <div>
                <a href={t('facebookLink')} target='_blank' rel='noopener noreferrer'>
                  <img src={FB} alt='Terramar facebook' />
                </a>
              </div>
              <div>
                <a href={t('instagramLink')} target='_blank' rel='noopener noreferrer'>
                  <img className={styles.last} src={INSTA} alt='Terramar Instagram' />
                </a>
              </div>
              <div>
                <a href={t('tiktokLink')} target='_blank' rel='noopener noreferrer'>
                  <img className={styles.last} src={TIKTOK} alt='Terramar Tik Tok' />
                </a>
              </div>
              <div>
                <a href={t('twitterLink')} target='_blank' rel='noopener noreferrer'>
                  <img className={styles.last} src={TWITTER} alt='Terramar Twitter' />
                </a>
              </div>
              <div>
                <a href={t('youtubeLink')} target='_blank' rel='noopener noreferrer'>
                  <img className={styles.last} src={YT} alt='Terramar youtube' />
                </a>
              </div>
            </div>
          </div>

          <div className={styles.chatRedes}>
            <div className={styles.iconChat}>
              <a
                href='https://m.me/terramarbrandscorporativo'
                target='_blank'
                rel='noopener noreferrer'>
                <img
                  className={styles.iconImage}
                  src='https://webimages.terramarbrands.com.mx/webpage/general/facebook_messenger_icono.png'
                  alt=''
                />
              </a>
            </div>

            <div className={styles.iconChat}>
              <a href={enlaceWhatsApp} target='_blank' rel='noopener noreferrer'>
                <img
                  className={styles.iconImage}
                  src='https://webimages.terramarbrands.com.mx/webpage/general/whatsapp_icono.png'
                  alt=''
                />
              </a>
            </div>
          </div>
        </div>
        <div className={styles.legal}>
          {t('rightsReserved')}
          <a href='/privacy' className={styles.link}>
            {t('privacyNotice')}{' '}
          </a>{' '}
          <a href='/terms' className={styles.link}>
            {t('terms')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
